"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    _classCallCheck(this, FormComponent);

    this.initNetteFormValidation();
    naja.registerExtension(new LoadingIndicatorExtension('.spinner-loading')); // AJAX FORM SENT

    /*let submitCurrentValue = "";
    $.nette.ext("genericFormAjax", {
        before: (jqXHR, settings) => {
            if (settings.hasOwnProperty("nette")) {
                submitCurrentValue = $(settings.nette.el).val();
                $(settings.nette.el).val("");
                $(settings.nette.el).addClass("sending");
            }
        },
        complete: (jqXHR, status, settings) => {
            if (settings.hasOwnProperty("nette")) {
                $(settings.nette.el).val(submitCurrentValue);
                $(settings.nette.el).removeClass("sending");
            }
        }
    });*/
  }
  /**
   * Nette Form Validation
   */


  _createClass(FormComponent, [{
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var validationType = $(form).attr("data-validationtype");
        var errorFind = false; // REMOVE ALL ERRORS FROM FORM

        $(".wrapper-form-input", form).removeClass("error");
        $(".error-text", form).remove();

        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              var field = $(error.element, form);
              errorFind = true;
              var wrapper = field.parents(".wrapper-form-input");
              wrapper.addClass("error"); // SET STYLE AS INVALID FIELD
              // ADD ERROR MESSAGE TO FIELD

              wrapper.prepend("<div class='error-text'>" + error.message + "</div>");
            });
        }

        if (errorFind === true) {
          if ($(".error-text", "html").length >= 1) {
            var errMessageElement = $(".error-text:first-of-type", "html");
            $([document.documentElement, document.body]).animate({
              scrollTop: errMessageElement.offset().top
            }, 2000);
          }
        }
      };
    }
  }]);

  return FormComponent;
}();

var LoadingIndicatorExtension = /*#__PURE__*/function () {
  function LoadingIndicatorExtension(defaultLoadingIndicatorSelector) {
    _classCallCheck(this, LoadingIndicatorExtension);

    this.defaultLoadingIndicatorSelector = defaultLoadingIndicatorSelector;
  }

  _createClass(LoadingIndicatorExtension, [{
    key: "initialize",
    value: function initialize(naja) {
      var _this = this;

      console.log("init");

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          _this.defaultLoadingIndicator = document.querySelector(_this.defaultLoadingIndicatorSelector);
        });
      } else {
        this.defaultLoadingIndicator = document.querySelector(this.defaultLoadingIndicatorSelector);
      }

      naja.uiHandler.addEventListener('interaction', this.locateLoadingIndicator.bind(this));
      naja.addEventListener('start', this.showLoader.bind(this));
      naja.addEventListener('complete', this.hideLoader.bind(this));
    }
  }, {
    key: "locateLoadingIndicator",
    value: function locateLoadingIndicator(event) {
      console.log("here2");
      console.log(event); //const loadingIndicator = event.detail.element.closest('[data-loading-indicator]');

      event.detail.options.loadingIndicator = event.detail.element;
    }
  }, {
    key: "showLoader",
    value: function showLoader(event) {
      var _event$detail$options;

      console.log("start");
      console.log(event);
      $(".spinner-loading").addClass("disable");
      (_event$detail$options = event.detail.options.loadingIndicator) === null || _event$detail$options === void 0 ? void 0 : _event$detail$options.classList.add('sending');
    }
  }, {
    key: "hideLoader",
    value: function hideLoader(event) {
      var _event$detail$options2;

      console.log("end");
      console.log(event);
      $(".spinner-loading").removeClass("disable");
      (_event$detail$options2 = event.detail.options.loadingIndicator) === null || _event$detail$options2 === void 0 ? void 0 : _event$detail$options2.classList.remove('sending');
    }
  }]);

  return LoadingIndicatorExtension;
}();